'use client';
import { createContext } from 'react';
import { companiesList } from '../contants';

type Context = {
  company: any;
};

export const CompanyContext = createContext<Context | null>(null);

export const CompanyProvider = ({ children }: { children: React.ReactElement }) => {
  const company = companiesList.filter(itm => itm.id == 'gss')[0]

  return (
    <CompanyContext.Provider
      value={{
        company,
      }}
    >
      {children}
    </CompanyContext.Provider>
  );
};

export default CompanyProvider;
